module.exports = __webpack_public_path__ + "winner-badge-team-1.af384b46870abe1cc1ab.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svgs/winner-badge-team-1.svg
// module id = ./src/assets/svgs/winner-badge-team-1.svg
// module chunks = main